<template>
<div class="chapter">
<div class="inner_page">
<p style="page-break-before: always; text-align: justify">Sobre o autor:</p>
<p style="text-align: justify">Antonio Pérez Hernández é professor do Ensino Fundamental (especialista em Educação Musical, Audição e Linguagem e Pedagogia Terapêutica), pedagogo, Mestre em Pesquisa e Inovação em Educação e Doutor, menção <span style="font-style: italic">cum laude, </span>pela sua Tese de Doutorado <span style="font-style: italic">Avaliação da competência em comunicação linguística por meio de histórias no Ensino Fundamental</span>.</p>
<p style="text-align: justify">Ele foi premiado com um segundo prêmio no Prêmio de Criação Literária Nemira e um resultado finalista no Concurso Internacional de Romance de Fantasia e Terror de Dagón. </p>
<p style="text-align: justify">Publicou mais de quarenta livros, traduzidos em sete idiomas: grego, alemão, português, italiano, inglês, francês e holandês. </p>
<p style="text-align: justify">Atualmente combina seu trabalho docente com a escrita.</p>
<p style="text-align: justify">Local na rede Internet:<a href="http://aphernandez.com" target="_blank">http://aphernandez.com</a></p>
<p style="text-align: justify">Twitter:<a href="https://twitter.com/ap_hernandez_" target="_blank">@ap_hernandez_</a></p>
<p style="text-align: justify">Instagram:<a href="https://www.instagram.com/ap_hernandez_/" target="_blank">@ap_hernandez_</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c003.vue?4ed1a818